import { useQuery } from 'src/core/api/hooks/useQuery';
import { type QueryState } from 'src/core/api/queryState';

import { reshapeApprovalScheme } from './reshape-approval-scheme';
import { type ApprovalScheme } from '../../company/structure/approval-flows';

export const useApprovalSchemeQuery = (
  approvalSchemeId: string | undefined,
): QueryState<ApprovalScheme> => {
  return useQuery<ApprovalScheme>({
    key: ['approval-scheme', approvalSchemeId],
    isEnabled: !!approvalSchemeId,
    request: {
      type: 'rest',
      target: 'companyAPI',
      endpoint: `/approval-scheme/${approvalSchemeId}`,
    },
    reshapeData: reshapeApprovalScheme,
  });
};
